import { Heart, Download, X, ChevronLeft, ChevronRight } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

// Full-screen photo viewer. Two modes:
//   • proofing: heart-to-favorite + per-photo note input
//   • delivery: download button when the gallery is unlocked
export default function Lightbox({
  photo,
  isFav,
  comment,
  setComment,
  onSaveComment,
  onToggleFav,
  onClose,
  onPrev,
  onNext,
  mode,
  downloadsAvailable,
  onDownload,
  idx,
  total,
}) {
  return (
    <div className="fixed inset-0 bg-stone-950/95 z-50 flex flex-col" data-testid="gallery-lightbox">
      <div className="flex items-center justify-between px-5 py-3 text-stone-200 text-xs">
        <div>{idx + 1} / {total}</div>
        <button
          onClick={onClose}
          className="w-9 h-9 inline-flex items-center justify-center hover:bg-white/10"
          data-testid="lightbox-close"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
      <div className="flex-1 flex items-center justify-center px-2 relative min-h-0">
        <button
          onClick={onPrev}
          className="absolute left-2 w-11 h-11 inline-flex items-center justify-center text-stone-200 hover:bg-white/10"
          aria-label="Previous"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
        <img src={`${BACKEND}${photo.url}?w=2000&q=82`} alt={photo.filename} className="max-h-full max-w-full object-contain" />
        <button
          onClick={onNext}
          className="absolute right-2 w-11 h-11 inline-flex items-center justify-center text-stone-200 hover:bg-white/10"
          aria-label="Next"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      </div>
      <div className="bg-stone-900/95 text-stone-100 px-4 py-4 sm:px-6">
        <div className="max-w-3xl mx-auto space-y-3">
          {mode === "proofing" && (
            <>
              <div className="flex flex-col sm:flex-row sm:items-center gap-3">
                <button
                  onClick={onToggleFav}
                  className={`inline-flex items-center justify-center gap-2 px-4 h-10 text-xs uppercase tracking-[0.18em] ${
                    isFav ? "bg-rose-500 hover:bg-rose-600 text-white" : "bg-stone-100 hover:bg-white text-stone-900"
                  }`}
                  data-testid="lightbox-fav-btn"
                >
                  <Heart className={`w-4 h-4 ${isFav ? "fill-white" : ""}`} />
                  {isFav ? "Favorited" : "Favorite for editing"}
                </button>
                <div className="text-xs text-stone-300 truncate">{photo.filename}</div>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2">
                <input
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Optional note for this photo (e.g. 'crop tighter, brighten skin')"
                  className="flex-1 bg-stone-800 border border-stone-700 px-3 py-2 outline-none focus:border-stone-100 text-sm placeholder:text-stone-500"
                  data-testid="lightbox-comment-input"
                />
                <button
                  onClick={onSaveComment}
                  className="px-4 h-10 bg-stone-700 hover:bg-stone-600 text-xs uppercase tracking-[0.18em]"
                  data-testid="lightbox-save-comment-btn"
                >
                  Save note
                </button>
              </div>
            </>
          )}
          {mode === "delivery" && downloadsAvailable && (
            <div className="flex items-center justify-between gap-3">
              <div className="text-xs text-stone-300 truncate">{photo.filename}</div>
              <button
                onClick={onDownload}
                className="inline-flex items-center gap-2 px-4 h-10 bg-stone-100 hover:bg-white text-stone-900 text-xs uppercase tracking-[0.18em]"
                data-testid="lightbox-dl-btn"
              >
                <Download className="w-4 h-4" /> Download
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
